import { type ClassStudent } from '../context/types';

export const getDisplayName = (student: ClassStudent): string => {
    if (student.user_name) {
        return student.user_name;
    }

    return [student.first_name || '', student.last_name || ''].join(' ').trim();
};
